import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { getBrand, getBrandConfig, getHostName } from '@blockpulse3/data/shared';
import { LoadingPage } from '@blockpulse3/ui/commons';
import { useUser } from '@blockpulse3/web-client/auth';

import { AppScreen, AuthScreen, IdentityScreen } from './screens';

const defaultZendeskSnippetSrc =
  'https://static.zdassets.com/ekr/snippet.js?key=7e36a96b-4e25-4a34-bc91-c056906e932e';

export function Screen(): JSX.Element {
  const { user, status, setStatus, loadUser } = useUser();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      loadUser();
    } else {
      setStatus('unauthenticated');
    }
  }, [loadUser, setStatus]);

  useEffect(() => {
    const setVh = (): void => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    window.addEventListener('load', setVh);
    window.addEventListener('resize', setVh);
    return () => {
      window.removeEventListener('load', setVh);
      window.removeEventListener('resize', setVh);
    };
  }, []);

  if (status === 'loading') {
    return <LoadingPage />;
  }

  if (status === 'unauthenticated') {
    return <AuthScreen />;
  }

  if (!user?.individualIdentity?.address) {
    /* ** Onboarding not completed ** */
    return <IdentityScreen />;
  }

  return <AppScreen />;
}

export function App(): JSX.Element {
  const hostname = getHostName();
  const brand = getBrand(hostname);
  const brandConfig = getBrandConfig(brand);

  return (
    <>
      <Helmet>
        <title>Tableau de bord - {brandConfig.name}</title>
        <link
          href={`assets/brands/${brandConfig.slug}/favicon.ico`}
          rel="icon"
          type="image/x-icon"
        />
        <script
          id="ze-snippet"
          src={brandConfig?.zendeskSnippetSrc || defaultZendeskSnippetSrc}
        ></script>
      </Helmet>
      <Screen />
    </>
  );
}

export default App;
